<template>
  <v-card class="my-1" elevation="0" style="height: 49%;">
    <v-card-title>
      <h5>Distribuição PSFP</h5>
    </v-card-title>
    <div
      v-if="loading"
      class="d-flex align-center justify-center"
      style="height: 70px;"
    >
      <v-progress-circular indeterminate color="primary" size="32" />
    </div>
    <v-card-text v-else>
      <highcharts :options="chartOptions" :deepCopyOnUpdate="false" />
    </v-card-text>
  </v-card>
</template>

<script>
import { getCorIsfpPsfpPorFaixa } from "@/utils/isfpPsfpFaixas";

export default {
  name: "DashboardIsfpPsfpDistribuicaoPsfpGeral",
  props: {
    distribuicao: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  computed: {
    chartOptions() {
      return {
        chart: { type: "column", height: 350 },
        credits: { enabled: false },
        title: { text: null },
        legend: { enabled: false },
        xAxis: {
          categories: this.distribuicao.map((d) => d.faixa_psfp),
          crosshair: true,
          labels: { style: { fontSize: "13px" } },
        },
        yAxis: {
          title: { text: null },
          labels: { style: { fontSize: "13px" } },
        },
        tooltip: {
          formatter() {
            return `<b>${this.x}</b><br/>Quantidade: ${this.y}`;
          },
        },
        plotOptions: {
          column: {
            dataLabels: { enabled: true, format: "{y}" },
          },
        },
        series: [
          {
            name: "Quantidade",
            animation: false,
            data: this.distribuicao.map((d) => ({
              y: d.quantidade,
              color: getCorIsfpPsfpPorFaixa(d.faixa_chave),
            })),
          },
        ],
        lang: { noData: "Sem dados para exibição" },
      };
    },
  },
};
</script>